import { useCallback, useEffect } from 'react';
import type { DataConfig } from '@/widgets/calendarInsights';
import {
  dataConfigValidator,
  selectMetaIsLoaded,
  updateConfig,
} from '@/widgets/calendarInsights';
import { ImportSharedPreset } from '@/features/SharePreset';
import { ROUTES } from '@/shared/constants';
import { Analytics } from '@/shared/lib';
import { useAppDispatch, useAppSelector } from '@/shared/model';
import { useViewInitializationStateMachineContext } from '@/shared/ui';

export function ImportSharedViewDialog() {
  const dispatch = useAppDispatch();
  const isColumnsMetaLoaded = useAppSelector(selectMetaIsLoaded);
  const { onNavigatedViewDetect, onNavigatedViewApply, onNavigatedViewError } =
    useViewInitializationStateMachineContext();

  useEffect(() => {
    onNavigatedViewDetect();
  }, [onNavigatedViewDetect]);

  const handleApplyPreset = useCallback(
    (preset: unknown) => {
      onNavigatedViewApply();
      dispatch(updateConfig(preset as DataConfig));
      Analytics.sendFeatureUsage('share_view', 'apply', {
        page: ROUTES.calendarInsights,
      });
    },
    [dispatch, onNavigatedViewApply],
  );
  const isPresetValid = useCallback((preset: unknown) => {
    const parseResult = dataConfigValidator.safeParse(preset);

    return parseResult.success;
  }, []);

  if (!isColumnsMetaLoaded) {
    return null;
  }

  return (
    <ImportSharedPreset
      isPresetValid={isPresetValid}
      applyPreset={handleApplyPreset}
      onPresetError={onNavigatedViewError}
    />
  );
}
